"use client"

import { ConversationWrapper, Icon, PhoneWrapper } from '@plura/client/components';
import { useFontLoader } from '@plura/client/hooks';
import { resetDefaultValuesToBlank } from "@plura/client/utils";
import { TemplateItem } from "@plura/shared/lead-forms";
import { cn } from "@plura/shared/utils";
import { useState } from "react";

interface Props {
  goBack: () => void;
  template: TemplateItem;
  action?: React.ReactNode;
}

const TemplatePreview = ({ goBack, template, action }: Props) => {
  const [previewMode, setPreviewMode] = useState<'MOBILE' | 'DESKTOP'>('DESKTOP')
  const [resetPreview, setResetPreview] = useState(false)
  const leadForm = template.formPreview
  const { fontsLoaded } = useFontLoader({
    fontFamily: leadForm.fontFamilySetting,
  });

  const handleReset = () => {
    setResetPreview(true)
    setTimeout(() => setResetPreview(false), 100)
  }

  return (
    <div className="flex min-h-0 w-full flex-1 flex-col overflow-hidden">
      <div className="flex items-center justify-between px-6 py-5 shrink-0">
        <div>
          <h5 className="text-h6 text-t-primary">{leadForm.name}</h5>
          <p className="text-caption text-t-secondary">This form works great on all screens and sizes</p>
        </div>
        <div className="flex items-center gap-1.5">
          <button
            type="button"
            onClick={goBack}
            className="flex items-center justify-center size-10 rounded-full border border-s-stroke2 transition-colors hover:border-s-highlight cursor-pointer"
          >
            <Icon name="chevron" className="!size-8 fill-t-secondary rotate-90" />
          </button>
          <div className="w-px h-5 bg-s-stroke2 mx-1" />
          <button
            type="button"
            onClick={() => setPreviewMode(previewMode === 'DESKTOP' ? 'MOBILE' : 'DESKTOP')}
            className={cn(
              'flex items-center justify-center size-10 rounded-full border border-s-stroke2 transition-colors hover:border-s-highlight cursor-pointer',
              previewMode === 'MOBILE' && 'bg-b-surface2'
            )}
          >
            <Icon name="mobile" className="!size-5 fill-t-primary" />
          </button>
          <button
            type="button"
            onClick={() => setPreviewMode(previewMode === 'DESKTOP' ? 'MOBILE' : 'DESKTOP')}
            className={cn(
              'flex items-center justify-center size-10 rounded-full border border-s-stroke2 transition-colors hover:border-s-highlight cursor-pointer',
              previewMode === 'DESKTOP' && 'bg-b-surface2'
            )}
          >
            <Icon name="tablet" className="!size-5 fill-t-primary" />
          </button>
          <div className="w-px h-5 bg-s-stroke2 mx-1" />
          <button
            type="button"
            onClick={handleReset}
            className="flex items-center justify-center size-10 rounded-full border border-s-stroke2 transition-colors hover:border-s-highlight cursor-pointer"
          >
            <Icon name="refresh" className="!size-5 fill-t-secondary" />
          </button>
          {action && action}
        </div>
      </div>

      <div className="min-h-0 flex-1 overflow-hidden px-6 pb-6">
        {previewMode === 'MOBILE' ? (
          <div className="flex h-full min-h-[320px] w-full justify-center overflow-hidden rounded-2xl bg-b-surface2 py-8 transition-all duration-200 dark:bg-shade-06 relative mx-auto">
            <PhoneWrapper>
              {!resetPreview && (
                <ConversationWrapper
                  key="preview-form"
                  wrapperId="preview-wrapper"
                  previewMode={true}
                  leadForm={leadForm}
                  fontsLoaded={true}
                  minimizeContentSize
                  currentStepOverride={null}
                  defaultValues={resetDefaultValuesToBlank(leadForm.journeyItems ?? [])}
                />
              )}
            </PhoneWrapper>
          </div>
        ) : (
          <div className="relative mx-auto h-full min-h-[320px] w-full overflow-hidden rounded-2xl transition-all duration-200">
            {!resetPreview && (
              <ConversationWrapper
                key="preview-form"
                wrapperId="preview-wrapper"
                previewMode={true}
                leadForm={leadForm}
                fontsLoaded={true}
                currentStepOverride={null}
                defaultValues={resetDefaultValuesToBlank(leadForm.journeyItems ?? [])}
              />
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default TemplatePreview;
